module.exports = __webpack_public_path__ + "static/img/detail_mogos1_product3.eb8dbf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/s1/detail_mogos1_product3.png
// module id = 673
// module chunks = 0